import { Component, Input } from '@angular/core';
import { Library } from '../../types/library';
import { CommonModule } from '@angular/common';
import { RouterLink } from "@angular/router";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-libraries-card',
  imports: [CommonModule, RouterLink, TranslateModule],
  templateUrl: './libraries-card.html',
  styleUrl: './libraries-card.scss',
})
export class LibrariesCard {
  @Input() library?: Library;

  /** Local default covers, picked by library id so each library keeps a stable image. */
  private static readonly FALLBACKS = [
    'images/custom/lib-cover-1.jpg',
    'images/custom/lib-cover-2.jpg',
    'images/custom/lib-cover-3.jpg',
    'images/custom/lib-cover-4.jpg',
  ];

  get fallbackImage(): string {
    const id = String(this.library?.library_id ?? '');
    let hash = 0;
    for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
    return LibrariesCard.FALLBACKS[hash % LibrariesCard.FALLBACKS.length];
  }

  dayNames: Record<string, string> = {
    '0': 'الأحد',
    '1': 'الإثنين',
    '2': 'الثلاثاء',
    '3': 'الأربعاء',
    '4': 'الخميس',
    '5': 'الجمعة',
    '6': 'السبت'
  };
}
